import { render, staticRenderFns } from "./form_common.vue?vue&type=template&id=30319828&scoped=true"
import script from "./form_common.vue?vue&type=script&lang=js"
export * from "./form_common.vue?vue&type=script&lang=js"
import style0 from "./form_common.vue?vue&type=style&index=0&id=30319828&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30319828",
  null
  
)

export default component.exports